'use client';

import classNames from 'classnames';
interface Props {
  label: string;
  isChecked: boolean;
  name: string;
  onStateChange?: (state: boolean) => void;
  className?: string;
}
export function ToggleSwitch({
  label,
  name,
  isChecked,
  onStateChange,
  className
}: Props) {
  const onChangeStatus = (checked: boolean) => {
    onStateChange && onStateChange(checked);
  };
  return <label className={classNames('relative flex cursor-pointer flex-row items-center justify-between gap-2 text-sm lg:text-base', className)} data-sentry-component="ToggleSwitch" data-sentry-source-file="toggle-switch.tsx">
            <span>{label}</span>
            <div className='relative w-9'>
                <input type='checkbox' onChange={e => onChangeStatus(e.target.checked)} name={name} checked={isChecked} className='peer/toggle hidden' />
                <span className='absolute -top-0.5 right-0 h-5 w-5 cursor-pointer appearance-none rounded-full bg-zinc-600 transition-all duration-500 ease-in-out peer-checked/toggle:right-4 peer-checked/toggle:bg-pink-600'></span>
                <span className='block h-4 cursor-pointer overflow-hidden rounded-full bg-neutral-200 transition-all duration-500 ease-in-out peer-checked/toggle:bg-red-100'></span>
            </div>
        </label>;
}